import { render, staticRenderFns } from "./Refund3DatingPage.vue?vue&type=template&id=52035fe1"
import script from "./Refund3DatingPage.vue?vue&type=script&lang=js"
export * from "./Refund3DatingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports